import {useCallback} from "react";

import {getTimeElapsedInSeconds} from "helpers/dateAndTime";
import {useFluxServices} from "injection/hooks";
import type {AnalyticsStorage} from "modules/storage_engine/AnalyticsStorage";
import {SurfaceBasedTrackingEvents} from "@buildwithflux/models";
import type {AutoLayoutClientJob} from "modules/auto_layout/services";

export function trackAutoLayoutEvent(
    analyticsStorage: AnalyticsStorage,
    action: string,
    currentJob?: AutoLayoutClientJob,
) {
    analyticsStorage.logEvent(SurfaceBasedTrackingEvents.pcbEditor, {
        surface: "AutoLayout",
        action,
        appliedIteration: currentJob?.currentIterationIndex,
        totalIterations: currentJob?.iterations.length,
        isLatestIteration: currentJob?.currentIterationIndex === currentJob?.iterations.length,
        timeElapsedInSeconds: getTimeElapsedInSeconds(currentJob?.startTime),
    });
}

export function useAutoLayoutAnalytics() {
    const {analyticsStorage} = useFluxServices();

    const trackEvent = useCallback(
        (action: string, currentJob?: AutoLayoutClientJob) => {
            trackAutoLayoutEvent(analyticsStorage, action, currentJob);
        },
        [analyticsStorage],
    );

    return {trackEvent};
}
